<template>
  <div v-if="open" class="modal-backdrop" @click.self="$emit('close')">
    <section class="modal">
      <header><h3>{{ title }}</h3><button class="icon-button" @click="$emit('close')">x</button></header>
      <slot />
    </section>
  </div>
</template>

<script setup lang="ts">
defineProps<{ open: boolean; title: string }>();
defineEmits<{ close: [] }>();
</script>
